import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
    AppLocale,
    DEFAULT_LOCALE,
    getPersistedLocale,
    normalizeLocale,
    persistLocale,
    SUPPORTED_LOCALES
} from './i18n.config';

@Injectable({ providedIn: 'root' })
export class LocaleService {
    readonly languages = SUPPORTED_LOCALES;
    currentLocale: AppLocale = DEFAULT_LOCALE;

    constructor(
        private translate: TranslateService,
        @Inject(DOCUMENT) private document: Document
    ) { }

    initialize(): void {
        this.currentLocale = getPersistedLocale();
        this.document.documentElement.lang = this.currentLocale;
        this.translate.addLangs(this.languages.map(language => language.code));
        this.translate.use(this.currentLocale).subscribe();
    }

    setLocale(locale: string): boolean {
        const normalized = normalizeLocale(locale);

        if (!normalized || normalized === this.currentLocale) return false;

        persistLocale(normalized);
        this.currentLocale = normalized;
        this.document.documentElement.lang = normalized;
        window.location.reload();

        return true;
    }
}
